<micro-select-combo #sel
              placeholder="Country"
              [mode]="mode"
              [(id)]="countryId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
